import axios from 'axios';

export const HTTP = (conf) => {
    const data = conf.data;
    const headers = {
        'Cache-Control' : 'no-cache'
    };
    let formData;

    if(['PUT', 'DELETE'].indexOf(conf.method) > -1) {
        formData = data;
    } else {
        formData = new FormData();
        Object.keys(data).forEach(key => {
            formData.append(key, data[key]);
        });
    }

    return axios({
        method: conf.method,
        url: conf.url,
        headers,
        data: formData,
        // withCredentials: true,
        // credentials: 'same-origin',
        // responseType: 'text',
        // proxy: {
        //    host: 'http://wasser.heliko.space',
        //    port: 80
        // }
    });
};
